<div class="chart-wrapper" *ngIf="trends?.length && trendsFiltered.length">
  <div *ngIf="chartOptions.series?.length">
    <h2 data-at-trending-chart-name>{{ name }}</h2>

    <div *ngIf="displayTooltip$ | async" class="mobile-tooltip">
      {{ '+INSTALLATIONS.INSTALLATION.TRENDING.CHARTS.DATA_AGGREGATED_WARNING_LABEL' | translate }}
    </div>

    <highcharts-chart
      class="highchart"
      [Highcharts]="highCharts"
      [constructorType]="'stockChart'"
      [options]="chartOptions"
      (chartInstance)="getChartInstance($event)"
      [oneToOne]="true"
    ></highcharts-chart>
    <div #customLegendContainer></div>
  </div>
</div>
